/*
 *   File : creator-disclosures-content.js
 *   Author : https://evoqins.com
 *   Description : Creator Disclosure , terms&conditions data modal
 *   Integrations : NA
 *   Version : 1.0.0
*/

// Components
import { Icon } from "../Icon"

function CreatorDisclosureContentModal(props) {

    // handle close modal
    const _handleCloseModal = () => {
        var button = document.getElementById("creator-content-modal-close");
        button.click();
        props.handleClose();
    };

    return (
        <div className="modal fade"
            id="creator-content-modal"
            data-bs-backdrop="static"
            data-bs-keyboard="false"
            tabIndex="-1"
            aria-labelledby="CreatorContentModalLabel"
            aria-hidden="true">
            <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable border-radius-16 modal-lg px-lg-5">
                <span id='creator-content-modal-close' className='d-none' data-bs-dismiss="modal"></span>
                <div className="modal-content border-radius-16 border-0 mx-lg-5 ">
                    {/* modal header */}
                    <div className="modal-header border-0 pt-2 justify-content-center align-items-center px-3 pb-0 position-relative">
                        <h4 className='e-font-16-res padding-12px-top mb-2 e-text-primary-color e-primary-font-clash-display e-font-18 e-font-weight-500 line-height-22px mb-4'>
                            {props.title}
                        </h4>
                        <Icon icon="close-icon"
                            size="20px"
                            className="cursor-pointer position-absolute top-0 end-0 m-4"
                            onPress={_handleCloseModal} />
                    </div>

                    {/* Modal body */}
                    <div className='modal-body pb-4 pt-0'>
                        <div id="creator-disclaimer" dangerouslySetInnerHTML={{ __html: props.data }}></div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CreatorDisclosureContentModal;